import React from 'react';
import { Link, useForm, usePage } from '@inertiajs/react';
import { Alert } from '../../components/Alert';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import ValidationError from '../../components/ValidationError';
import { useTrans } from '../../hooks/useTrans';
import AuthPanel from '../../components/layout/auth/AuthPanel';

export default function Activation({ email, activationUrl }) {
    const translate = useTrans();
    const { flash } = usePage().props;

    const { data, setData, post, processing, errors } = useForm({
        email: email ?? '',
        password: '',
        password_confirmation: '',
    });

    function handleSubmit(e) {
        e.preventDefault();
        post(activationUrl);
    }

    return (
        <>
            <AuthPanel>
                <h5 className="text-lg font-bold text-[#003545]">
                    {translate('Wachtwoord instellen')}
                </h5>
                <hr className="my-4 border-[#dfdfdf]" />

                <p className="text-sm text-[#003545] mb-2">
                    {translate('Vul hieronder je nieuwe wachtwoord in. Na het aanmaken je wachtwoord is je account geactiveerd en wordt je automatisch ingelogd.')}
                </p>

                <hr className="my-4 border-[#dfdfdf]" />

                {flash && <Alert variant={flash.type}>{flash.description}</Alert>}

                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-bold text-[#003545] mb-1">
                                {translate('E-mailadres')}
                            </label>
                            <Input
                                type="email"
                                value={email}
                                readOnly
                                className="h-[44px] font-normal"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-bold text-[#003545] mb-1">
                                {translate('Wachtwoord')}
                            </label>
                            <Input
                                type="password"
                                value={data.password}
                                onChange={(e) => setData('password', e.target.value)}
                                autoFocus
                                className="h-[44px] font-normal"
                            />
                            <ValidationError message={errors.password} />
                        </div>

                        <div>
                            <label className="block text-sm font-bold text-[#003545] mb-1">
                                {translate('Herhaal wachtwoord')}
                            </label>
                            <Input
                                type="password"
                                value={data.password_confirmation}
                                onChange={(e) => setData('password_confirmation', e.target.value)}
                                className="h-[44px] font-normal"
                            />
                            <ValidationError message={errors.password_confirmation} />
                        </div>

                        <Button variant="primary" type="submit" disabled={processing} className="w-full">
                            {translate('Aanmaken')}
                        </Button>
                    </div>
                </form>
            </AuthPanel>

            <Link href="/login" className="mt-4 block text-center text-sm text-white/60 no-underline hover:text-white">
                {translate('Annuleren')}
            </Link>
        </>
    );
}
